import { currencySymbol, postcodeWords, roundConfig, roundDay } from './round-config'
import { dayLabel } from './ui'

// "I've passed this to Liam, who built Roundly. He'll email you back by 3:40pm today." The time is
// shown on the round's clock (UK time for every UK round).
export function sentWords(replyBy: string | null, now: Date = new Date()): string {
  const first = "I've passed this to Liam, who built Roundly."
  if (!replyBy) return `${first} He'll email you back within two working hours.`
  const at = new Date(`${replyBy.trim().replace(' ', 'T')}Z`)
  if (Number.isNaN(at.getTime())) return `${first} He'll email you back within two working hours.`
  const clock = new Intl.DateTimeFormat('en-GB', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: roundConfig().timeZone })
    .format(at).replace(/\s/g, '').toLowerCase()
  const day = roundDay(at)
  const today = roundDay(now)
  const tomorrow = roundDay(new Date(now.getTime() + 24 * 3600_000))
  const gapDays = (Date.parse(`${day}T12:00:00Z`) - Date.parse(`${today}T12:00:00Z`)) / 86_400_000
  const when = day === today ? 'today' : day === tomorrow ? 'tomorrow'
    : gapDays > 0 && gapDays < 7 ? new Date(`${day}T12:00:00Z`).toLocaleDateString('en-GB', { weekday: 'long', timeZone: 'UTC' })
    : dayLabel(day)
  return `${first} He'll email you back by ${clock} ${when}.`
}

// Help's UK-only phrases, as a US round reads them (Step 2 round 4).
const US_HELP: [string, string][] = [
  ['(a number about £2 a month, a text about 3p)', "(a number about $1.15 a month, a text about 1¢ plus the carriers' fees)"],
  ['buy a UK mobile number', 'buy a US local number'],
]

// A Help answer in the round's own words: "ZIP code" and $ for a US round, and its own Twilio number and prices. A UK
// round's answers exactly as written.
export function helpWords(text: string): string {
  if (currencySymbol() === '£') return text
  const swapped = roundConfig().country === 'US' ? US_HELP.reduce((t, [uk, us]) => t.replace(uk, us), text) : text
  return postcodeWords(swapped).replace(/£/g, '$')
}
